module.exports = __webpack_public_path__ + "static/img/2en.5df10e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/lianxiang/2en.png
// module id = cboW
// module chunks = 0